import * as dealInfoHelpers from 'shared/utils/deal-info-helpers';


export function isSaleEnabled(video) {
  return Boolean(video && dealInfoHelpers.getSalePriceInfo(video.dealInfo));
}

export function isRentEnabled(video) {
  return Boolean(video && dealInfoHelpers.getRentPriceInfo(video.dealInfo));
}

export function isBought(video) {
  return Boolean(_.get(video, 'dgsInfo.sale'));
}

export function isRented(video) {
  return Boolean(_.get(video, 'dgsInfo.rent'));
}

export function isOwned(video) {
  return isRented(video) || isBought(video);
}

export function isFree(video) {
  return !isSaleEnabled(video) && !isRentEnabled(video);
}



// WEBPACK FOOTER //
// ./src/shared/ui-selectors/video/pricing.js